import { render, staticRenderFns } from "./bedroom.vue?vue&type=template&id=63223174&scoped=true&"
import script from "./bedroom.vue?vue&type=script&lang=js&"
export * from "./bedroom.vue?vue&type=script&lang=js&"
import style0 from "./bedroom.vue?vue&type=style&index=0&id=63223174&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63223174",
  null
  
)

export default component.exports